import Papa from 'papaparse';

export type CsvRow = Record<string, unknown>;

function collectColumns(rows: CsvRow[], preferredColumns: readonly string[] = []): string[] {
  const columns = new Set(preferredColumns);
  rows.forEach((row) => Object.keys(row).forEach((column) => columns.add(column)));
  return [...columns];
}

export function rowsToCsv(rows: CsvRow[], preferredColumns: readonly string[] = []): string {
  const columns = collectColumns(rows, preferredColumns);
  if (columns.length === 0) return '';

  return Papa.unparse(
    {
      fields: columns,
      data: rows.map((row) => columns.map((column) => row[column] ?? null)),
    },
    {
      header: true,
      newline: '\r\n',
      quotes: false,
    },
  );
}
